import { client } from "../client";
import { Patient } from "../types/patient.types";

export const createPatient = async ({
	patient,
}: {
	patient: Partial<Patient>;
}) => {
	const response = await client.post<Patient>(`/patients/`, patient);
	return response.data;
};

export const updatePatient = async ({
	patient,
}: {
	patient: Partial<Patient>;
}) => {
	const response = await client.patch<Patient>(
		`/patients/${patient.id}/`,
		patient,
	);
	return response.data;
};
